import {
  type DashboardActions,
  InternalMembersActions,
} from '@store/reducers/dashboard/actions'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* remove({
  payload,
}: ReturnType<typeof DashboardActions.members.delete>) {
  const { workspaceId, id } = payload
  yield put(InternalMembersActions.remove(payload))
  try {
    yield call(NestClient.membership.remove, workspaceId, id)
    yield call(sendGtmEvent, GtmTriggerName.TEAM_MEMBER_REMOVE)
  } catch (e) {
    console.error('Error while removing member', e)
    yield put(GeneralErrorNotification)
  }
  yield put(InternalMembersActions.fetchList({ workspaceId }))
}
